import { css } from '@emotion/react';
import NvCheckbox from 'shared/components/inputs/nv-checkbox';
import { CellProps } from './types';


const CheckboxCell = ({ cell, className }: CellProps) => {
  const { user } = cell.getValue();
  const {
    table: {
      options: { meta },
    },
  } = cell.getContext();
  const {
    isUserSelected,
    setSelectedUsers,
  } = meta;

  const handleCheckboxChange = () => {
    setSelectedUsers((prevSelected) => (
      prevSelected.some(({ id }) => id === user.id)
        ? prevSelected.filter(({ id }) => id !== user.id)
        : [...prevSelected, user]
    ));
  };

  return (
    <div className={className}>
      <NvCheckbox
        name=''
        label=''
        checked={isUserSelected(user.id)}
        onChange={handleCheckboxChange}
      />
    </div>
  );
};

export default CheckboxCell;
